/* External */
import { memo } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

/* Ott-common */
import LiveStartTimeCommon from '@dtvgo/live-start-time';

/* Utils */
import { useCurrentTime } from '../../providers/CurrentTimeProvider';
import useLiveContentTexts from '../../hooks/useLiveContentTexts';

function LiveStartTime({
  startDate = undefined,
  endDate = undefined,
  children = undefined,
  className = '',
  showStartInText = true,
  showFinishedText = false,
  showLiveIcon = true,
}) {
  const { formatMessage, timeZone } = useIntl();
  return (
    <LiveStartTimeCommon
      currentTime={new Date(useCurrentTime() * 60_000)}
      startDate={startDate}
      endDate={endDate}
      formatTextTime={useLiveContentTexts()}
      className={className}
      textLive={formatMessage({ id: 'common.live' })}
      showStartInText={showStartInText}
      showLiveIcon={showLiveIcon}
      showFinishedText={showFinishedText}
      timeZone={timeZone}
    >
      {children}
    </LiveStartTimeCommon>
  );
}

LiveStartTime.propTypes = {
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  children: PropTypes.node,
  className: PropTypes.string,
  showStartInText: PropTypes.bool,
  showFinishedText: PropTypes.bool,
  showLiveIcon: PropTypes.bool,
};

export default memo(LiveStartTime);
